/**
 * Created by slava on 4/21/17.
 */

const VKPayments = function (name, options = {}) {
    RestPayments.call(this, name || connector.VK, options);
};

VKPayments.prototype = Object.create(RestPayments.prototype);
VKPayments.prototype.constructor = VKPayments;

VKPayments.prototype.getDefaultCurrency = function () {
    return "VK_GOLOS";
};

VKPayments.prototype.getTextPrice = function (price) {
    const ld = price % 10;
    if (ld === 1 && (price < 10 || price > 20)) {
        return `${price} голос`;
    }
    if (ld > 1 && ld < 5 && (price < 10 || price > 20)) {
        return `${price} голоса`;
    }
    return `${price} голосов`;
};

VKPayments.prototype.purchaseOpen = function (product, callback) {
    connector.platform.callNative("VKWebAppShowOrderBox", {
        type: "item",
        item: product.itemId
    }, (code, data) => {
        if (code === connector.CODE_SUCCEED) {
            const purchase = this.createPurchase(data.order_id, product);

            callback(connector.CODE_SUCCEED, purchase);
        } else if (data && data.error_data && data.error_data.error_reason === "User denied") {
            callback(ERRORS.PURCHASE.CANCEL);
        } else {
            const err = data && data.error_data || data;

            callback(ERRORS.PURCHASE.UNKNOWN, undefined, { error: err && err.error_code, message: err && err.error_reason });

            this.bus.trigger("stream:error", `VKPayments.purchase productId: ${product.productId} ${JSON.stringify(data)}`);
        }
    });
};

VKPayments.prototype.canDeliverLate = function () {
    return true;
};

VKPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.VK);
};